import { format, ISelectOption, UpdateMethod, UpdateMethodType } from 'shell-models-lib';
import { cloneDeep } from 'lodash';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';

const _APPEND_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.SinkTransformationSavePolicyAppend,
    value: UpdateMethod.Append,
    labelIcon: 'svg-c_append_data_32',
    description: stringResources.CopyJob_AppendDataDescription
};

const _OVERWRITE_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.Overwrite,
    value: UpdateMethod.Overwrite,
    labelIcon: 'svg-c_replace_data_32',
    description: stringResources.CopyJob_OverwriteDataDescription
};

const _UPSERT_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.MergeLabel,
    value: UpdateMethod.Upsert,
    labelIcon: 'svg-c_upsert_data_32',
    description: stringResources.CopyJob_MergeDataDescription
};

const _MERGE_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.MergeLabel,
    value: UpdateMethod.Merge,
    labelIcon: 'svg-c_upsert_data_32'
};

const _REPLACE_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.Azure_Table_InsertType_Replace_Option_Label,
    value: UpdateMethod.Replace,
    labelIcon: 'svg-c_replace_data_32'
};

const _SCD2_OPTION: ISelectOption<UpdateMethodType> = {
    label: stringResources.WriteBehavior_Option_SCD2,
    value: UpdateMethod.SCD2,
    labelIcon: 'svg-c_scd2_32'
};

export const ALL_UPDATE_METHOD_OPTIONS: Array<ISelectOption<UpdateMethodType>> = [
    _APPEND_OPTION,
    _OVERWRITE_OPTION,
    _UPSERT_OPTION,
    _MERGE_OPTION,
    _REPLACE_OPTION,
    _SCD2_OPTION
];

const _getOption = (updateMethod: UpdateMethodType, preview = false) => {
    let option: ISelectOption<UpdateMethodType> = ALL_UPDATE_METHOD_OPTIONS.find(
        (option) => option.value === updateMethod
    );
    if (option == null) {
        throw new Error(`Update method ${updateMethod} not found`);
    }
    option = cloneDeep(option);
    if (preview) {
        option.label = format(stringResources.ModelName_DisplayTextPreviewTemplate, option.label);
    }
    return option;
};

export const getAppendOption = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.Append, preview);

export const getOverwriteOption = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.Overwrite, preview);

export const getUpsertOption = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.Upsert, preview);

export const getMergeOption = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.Merge, preview);

export const getReplaceOption = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.Replace, preview);

export const getSCD2Option = (preview?: boolean): ISelectOption<UpdateMethodType> =>
    _getOption(UpdateMethod.SCD2, preview);

export const UPDATE_METHOD_TO_WRITE_BEHAVIOR_MAP: Map<string, string> = new Map([
    [UpdateMethod.Append, writeBehaviorOptionValues.insert],
    [UpdateMethod.Upsert, writeBehaviorOptionValues.upsert],
    [UpdateMethod.Replace, writeBehaviorOptionValues.upload],
    [UpdateMethod.Merge, writeBehaviorOptionValues.merge],
    [UpdateMethod.SCD2, writeBehaviorOptionValues.SCD2]
]);
